<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h1>{{ 'repository.contacts.title' | translate }}</h1>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="creation-form">
            <button *ngIf="!isCreationMode" (click)="onEdit()"
                [matTooltip]="'repository.contacts.list.add' | translate"
                mat-mini-fab class="action-button" color="accent">
                <mat-icon aria-label="Add">person_add</mat-icon>
            </button>
            <app-contact-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-contact-edit>
        </section>
        <section class="datatable-container">
            <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
                <ng-container matColumnDef="civility">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.civility' | translate }} </th>
                    <td mat-cell *matCellDef="let contact" class="civility"> {{ civility[contact.civility] }} </td>
                </ng-container>

                <ng-container matColumnDef="firstname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.firstname' | translate }} </th>
                    <td mat-cell *matCellDef="let contact"> {{ contact.firstname }} </td>
                </ng-container>

                <ng-container matColumnDef="lastname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.lastname' | translate }} </th>
                    <td mat-cell *matCellDef="let contact"> {{ contact.lastname }} </td>
                </ng-container>

                <ng-container matColumnDef="mobilePhone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.mobilePhone' | translate }} </th>
                    <td mat-cell *matCellDef="let contact"> {{ contact.mobilePhone }} </td>
                </ng-container>

                <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.phone' | translate }} </th>
                    <td mat-cell *matCellDef="let contact"> {{ contact.phone }} </td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.email' | translate }} </th>
                    <td mat-cell *matCellDef="let contact"> {{ contact.email }} </td>
                </ng-container>

                <ng-container matColumnDef="client">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Client </th>
                    <td mat-cell *matCellDef="let contact">
                        {{ contact.client.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="identifier">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.contacts.list.identifier' | translate }} </th>
                    <td mat-cell *matCellDef="let contact"> {{ contact.identifier }} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> {{ 'repository.contacts.list.actions' | translate }} </th>
                    <td mat-cell *matCellDef="let contact">
                        <ng-container *ngIf="contact.id !== editedId">
                            <button mat-icon-button class="action-button" color="accent"
                                [disabled]="isLoading"
                                [matTooltip]="'repository.contacts.list.edit' | translate"
                                (click)="onEdit(contact.id)">
                                <mat-icon aria-label="Edit">edit</mat-icon>
                            </button>
                        </ng-container>
                        <ng-container>
                            <button mat-icon-button class="action-button" color="accent"
                                [disabled]="isLoading"
                                [matTooltip]="'repository.contacts.list.delete' | translate"
                                (click)="delete(contact.id)">
                                <mat-icon aria-label="Delete">clear</mat-icon>
                            </button>
                        </ng-container>
                    </td>
                </ng-container>

                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let contact" [attr.colspan]="displayedColumns.length">
                        <div *ngIf="contact.id === editedId" class="row-edit"
                            [@detailExpand]="contact.id === editedId ? 'expanded' : 'collapsed'">
                            <app-contact-edit [contact]="contact" (editFinished)="onEditFinished()"></app-contact-edit>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
                    [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
            </table>
        </section>
        <mat-progress-bar *ngIf="isLoading"  class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
    </mat-card-content>
</mat-card>
